import { IChatV2Schema } from '@cian/chats-api';

import { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import {
  fetchChatsUnmarkAsStarred,
  TChatsUnmarkAsStarredRequest,
  TChatsUnmarkAsStarredResponse,
} from '../../repositories/chats/v1/chats/unmark-as-starred';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { deselectAllChats, toggleChatListPending, updatedFromServer } from '../chatList/actions';

/**
 * Пометить чат как не важный
 * @param parameters.chatId id чата
 */
export const unmarkChatAsStarred =
  (parameters: TChatsUnmarkAsStarredRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger, telemetry } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsUnmarkAsStarredResponse = await fetchChatsUnmarkAsStarred({
        httpApi,
        config: { requestConfig: { withCredentials: true } },
        parameters: { chatId: parameters.chatId },
      });
      if (statusCode === 200 && response.chat) {
        const chat = response.chat as unknown as IChatV2Schema;

        dispatch(updatedFromServer(chat));
        telemetry.increment(ETelemetryEvents.UnmarkMessagesAsStarredSuccess);
        dispatch(deselectAllChats());

        /**
         * При успешном помечании чата как важного, показываем алерт
         */
        dispatch(showAlert({ type: EAlert.Info, message: 'Чат удален из важных' }));
      } else {
        const { message } = (response as IErrorResponseSchema) || {};
        const errors = (response as IErrorResponseSchema)?.errors;
        telemetry.increment(ETelemetryEvents.UnmarkMessagesAsStarredFail);
        logger.warning('Код ответа не 200', {
          message: 'Не удалось чат убрать из важных',
          domain: 'src/shared/actions/chatList/unmarkChatAsStarred.ts',
          statusCode,
          messsage: message || 'Неизвестная ошибка',
          errors: JSON.stringify(errors),
        });

        dispatch(showAlert({ message: 'Не удалось чат убрать из важных' }));
      }
    } catch (ex) {
      telemetry.increment(ETelemetryEvents.UnmarkMessagesAsStarredFail);
      logger.error(ex, {
        message: 'Не удалось чат убрать из важных',
        domain: 'src/shared/actions/chatList/unmarkChatAsStarred.ts',
      });

      dispatch(showAlert({ message: 'Не удалось чат убрать из важных' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
